/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag jsx
 */

import { css, jsx } from '@compiled/react';

import { SmartCardProvider } from '@atlaskit/link-provider';

import { LinkListCompact } from './link-list-compact';
import { LinkListFull } from './link-list-full';
import type { OnLinkClick } from './types';

interface LinkListProps {
	headerVisible?: boolean;
	onLinkClick?: OnLinkClick;
	urls: string[];
}

const containerRoot = css({
	width: '100%',
	containerType: 'inline-size',
	containerName: 'link-list-knowledge-card-container',
});

const showCompact = css({
	display: 'block',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
	'@container link-list-knowledge-card-container (min-width: 481px)': {
		display: 'none',
	},
});

const showFull = css({
	display: 'none',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
	'@container link-list-knowledge-card-container (min-width: 481px)': {
		display: 'block',
	},
});

export const DEFAULT_MAX_SOURCES = 4;

export const LinkList = ({ urls, onLinkClick }: LinkListProps): JSX.Element => {
	return (
		<div css={containerRoot}>
			<SmartCardProvider>
				<div css={showCompact}>
					<LinkListCompact urls={urls} onLinkClick={onLinkClick} />
				</div>
				<div css={showFull}>
					<LinkListFull urls={urls} onLinkClick={onLinkClick} />
				</div>
			</SmartCardProvider>
		</div>
	);
};
